import React, { useEffect } from "react";
import "./css/Home.css";
import { Link } from "react-router-dom";

function Home() {

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const className = index % 2 === 0 ? "sideleftone" : "siderightone";
          entry.target.classList.add(className);
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(".service-one").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div>

<div className="banner">
  <h1>Welcome to Doddamani TechDev Pvt Ltd</h1>
  <p>
    We build Web Applications, Mobile Applications, Desktop Software, IoT Projects 
    and provide Software Training for Students. 
    Our services are available both <b>online and offline</b> across the 
    <b> state, national, and international level.</b>
  </p>
</div>

      <div className="container">

        <p className="paragraps">
  In today's digital age, having a strong online presence is important for businesses.
  At Doddamani TechDev Pvt Ltd, we help businesses and students transform their ideas
  into powerful digital solutions. We provide services such as web application
  development, mobile app development, desktop software development, IoT projects,
  and student academic projects.

  Our services are available both <b>online and offline</b>. We support clients
  across the <b>state, national, and international level</b>, ensuring quality
  solutions and professional guidance wherever our clients are located.
</p>

        <h2 className="center-title">Our Services</h2>

        <div className="ourserver-card">

          <div className="service-one">
            <p className="sub-title">Custom Web Application Development</p>
            <h3>
              We design and develop powerful and scalable web applications
              tailored to your business needs using modern technologies.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">Mobile Application Development</p>
            <h3>
              Our team builds Android and iOS applications that provide smooth
              performance and excellent user experience.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">Desktop Software Development</p>
            <h3>
              We develop customized desktop software solutions for businesses,
              industries and organizations.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">IoT Projects</p>
            <h3>
              We provide innovative Internet of Things (IoT) projects for
              industries, startups, and engineering students.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">Student Projects</p>
            <h3>
              Final year projects, mini projects, and research projects are
              developed with complete guidance and documentation.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">Software Training</p>
            <h3>
              We provide practical training in MERN Stack, React, Python,
              Database systems and modern web technologies.
            </h3>
          </div>

          <div className="service-one">
            <p className="sub-title">Tech issue solutions</p>
            <h3>
                We fix all the technical issue's as parcelly who has done incomplite assigments
            </h3>
          </div>

                    <div className="service-one">
            <p className="sub-title">Data Enter solutions</p>
            <h3>
                Our team's help for entery all the N number of data enter
            </h3>
          </div>


        </div>

                  <div className="service-two">
  <h2>Service Availability</h2>
  <p>
    Doddamani TechDev Pvt Ltd provides services both online and offline.
    We support clients across the state, national, and international levels.
    Students, startups, and businesses can access our services from anywhere.
  </p>
</div>


        {/* Vision & Mission */}
        <div className="layer-3-home">

          <div className="layer3-items">
            <h2 className="center-title">Our Vision</h2>
            <div className="center-title-two-items">
              Our vision is to empower businesses and students through
              technology by delivering innovative digital solutions that
              simplify operations, improve productivity, and create new
              opportunities for growth.
            </div>
          </div>

          <div className="layer3-items">
            <h2 className="center-title">Our Mission</h2>
            <div className="center-title-two-items">
              Our mission is to deliver high-quality software solutions,
              provide professional training to students, and help businesses
              transition successfully into the digital world.
            </div>
          </div>

        </div>

      </div>


      {/* Why Choose */}
      <div className="why-smservices-title">
        Why Choose Doddamani TechDev Pvt Ltd?
      </div>

      <ul className="layer3-ul">

        <li>
          <b>Expert Developers:</b> Our team consists of skilled developers
          experienced in modern technologies.
        </li>

        <li>
          <b>Customized Solutions:</b> Every project is designed according to
          your business requirements.
        </li>

        <li>
          <b>Affordable Pricing:</b> We provide high-quality solutions at
          competitive prices.
        </li>

        <li>
          <b>Latest Technologies:</b> We work with modern frameworks like
          React, Node.js, Python, and cloud platforms.
        </li>

        <li>
          <b>Full Support:</b> From project planning to deployment and
          maintenance we support you completely.
        </li>

      </ul>


      {/* Contact Box */}
      <div className="message-box">
        <h2>For Register</h2>
   <h4>
  Click here to <Link to="/contact">Contact Us</Link>
</h4>
           </div>


    </div>
  );
}

export default Home;